// Mixpanel helpers for the retailer dashboard (spec: buyer-insights-dashboard-surfaces.md §0.10).
// `track` is a no-op when Mixpanel is not initialised (no token) and never throws.
// Never send product names, prices or partner names as properties — ids and enum values only.
import mixpanel from 'mixpanel-browser';

export function track(event, props = {}) {
  try {
    if (mixpanel && mixpanel.__loaded) {
      mixpanel.track(event, props);
    }
  } catch (_e) {
    // tracking is best-effort
  }
}

// Route patterns, most specific first. `Retailer Page Viewed` sends the pattern, never an id.
export const ROUTE_PATTERNS = [
  '/commissions/:id',
  '/commissions',
  '/invoices/:id',
  '/invoices',
  '/self-bills/:id',
  '/network/:partnerId',
  '/network',
  '/order-bidding',
  '/settings/partner-rules/:id/change',
  '/settings/partner-rules/new',
  '/settings/partner-rules',
  '/settings/visibility',
  '/settings/ai-assistants',
  '/settings',
  '/',
];

// Tiny matcher (segments, `:param` wildcards) so this file has no router dependency — CRA's Jest
// cannot resolve react-router-dom v7's ESM-only package.
function matches(pattern, pathname) {
  const p = pattern.split('/').filter(Boolean);
  const u = pathname.split('/').filter(Boolean);
  if (p.length !== u.length) return false;
  return p.every((seg, i) => seg.startsWith(':') || seg === u[i]);
}

export function routePattern(pathname) {
  for (const pattern of ROUTE_PATTERNS) {
    if (matches(pattern, pathname)) return pattern;
  }
  // Unknown route: strip anything that looks like an id so nothing identifying leaks.
  return pathname.replace(/[0-9a-f]{8}-[0-9a-f-]{27,}/gi, ':id').replace(/\/\d+(?=\/|$)/g, '/:id');
}
